import Component from 'vue-class-component'
import BaseComponent from '@/components/base/BaseComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {Action, Getter} from 'vuex-class'
import {Watch} from 'vue-property-decorator'

@Component({})
export default class IdleModalComponent extends BaseComponent {

    @Action('logout', StoreNamespace.AUTHORIZATION) logout: any
    @Action('resetStore') resetStore: any
    @Getter('appIsIdle') appIsIdle!: boolean
    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string

    /*idle*/
    private intervalId: any = 0
    private timeoutId: any = 0
    private timerMs: number = 1000 * 60 * +(process.env.VUE_APP_IDLE_TIME || 5) //2 minutes
    private idleSecondCounter: number = this.timerMs / 1000
    private firstTime: boolean = true

    @Watch('appIsIdle')
    onAppIsIdleChanged(newVal: any, oldVal: any) {
        if (this.firstTime) {
            this.firstTime = false
            return
        }
        this.idleSecondCounter = this.timerMs / 1000
        if (newVal) {
            (this.$refs.idleModal as any).show()
            this.startTimer()
        } else {
            clearInterval(this.intervalId)
            clearTimeout(this.timeoutId)
        }
    }

    startTimer() {
        clearInterval(this.intervalId)
        this.intervalId = setInterval(this.countDown, 1000)

        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
            clearInterval(this.intervalId)
            this.logoutFromApp()
        }, this.timerMs)
    }

    countDown() {
        this.idleSecondCounter -= 1
    }

    logoutFromApp() {
        this.logout({requestorCallback: this})
    }

    onSuccess(data?: any, requestName?: any, message?: any) {
        this.resetStore()
        if (this.mngCompanyName) {
            this.$router.push('/login/' + this.mngCompanyName)
        } else {
            this.$router.push({name: 'success-logout'})
        }
    }

    /*computed*/
    get seconds() {
        let s: any = ((this.idleSecondCounter % 60) + '')
        return s.padStart(2, '0')
    }

    get minutes(): number {
        let s: any = (Math.trunc(this.idleSecondCounter / 60) + '')
        return s.padStart(2, '0')
    }

    hideModal() {
        var idleModal: any = this.$refs.idleModal
        idleModal.hide()
    }

    onHideModal() {
        clearInterval(this.intervalId)
        clearTimeout(this.timeoutId)
    }
}